import { createRoot } from "react-dom/client";
import "./index.css";
import { HeroUIProvider } from "@heroui/react";
import { BrowserRouter } from "react-router-dom";
import { SessionSyncProvider } from "./SessionSyncProvider";
import App from "./App.tsx";
import { ErrorInfo, useEffect } from "react";
import SharedModal from "../shared/components/modal/Shared-Modal.tsx";
import ModalManager from "../shared/components/modal/Modal-Manager.ts";
import { sendErrorFeedback } from "../shared/utils/helpers.ts";
import { ErrorBoundary } from "react-error-boundary";
import setupApplicationInsights from "../shared/services/setupAppInsights.ts";

// Function to register the service worker
const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js") // Adjust path if needed
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          );

          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;

            if (newWorker) {
              newWorker.addEventListener("statechange", () => {
                if (
                  newWorker.state === "installed" &&
                  navigator.serviceWorker.controller
                ) {
                  // New content is available, trigger an event
                  console.log("New content is available, please refresh!");
                  window.dispatchEvent(new Event("new-content-available"));
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    });
  }
};

export const Main = () => {
  // Register service worker when the app loads
  useEffect(() => {
    registerServiceWorker();
    setupApplicationInsights();
  }, []);

  const handleError = (error: Error, info: ErrorInfo) => {
    ModalManager.show({
      size: "lg",
      header: "Contact MSI - Unexpected Error",
      message: error?.message || "An error occurred",
      messageDetails: `${error?.stack}\n\nComponent Stack:\n${info.componentStack}`,
      //TODO: send error to MSI onConfirm and forward to MSI main website
      onCancel: () => {
        window.location.reload();
      },
      onConfirm: () => {
        sendErrorFeedback(error);
      },
      cancelButtonText: "Refresh",
      actionButtonText: "Send to MSI",
    });
  };

  return (
    <HeroUIProvider>
      <ErrorBoundary onError={handleError} fallbackRender={() => null}>
        <SessionSyncProvider />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
      <SharedModal />
    </HeroUIProvider>
  );
};

// Render the application
createRoot(document.getElementById("root")!).render(<Main />);
